import { render, staticRenderFns } from "./manually-upload.vue?vue&type=template&id=5a16653e&scoped=true&"
import script from "./manually-upload.vue?vue&type=script&lang=js&"
export * from "./manually-upload.vue?vue&type=script&lang=js&"
import style0 from "./manually-upload.vue?vue&type=style&index=0&id=5a16653e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a16653e",
  null
  
)

export default component.exports